export default __webpack_public_path__ + "static/771-702b1cf93c499bdf56cce08dcce990ac.gif";